import HeaderLogo from '@/assets/logo_twm.png'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import { Image, Page, Text, View } from '@react-pdf/renderer'
import PDFTitle from './PDFTitle'

const PDFPage = ({ children, title, hideTitleDivider, reportData, color }) => {
  const { reprotDao, secondaryCompanyFullname } = reportData || {}
  const { companyName } = reprotDao || {}

  return (
    <Page
      dpi={140}
      size="A4"
      style={{
        display: 'flex',
        fontFamily: 'Noto Sans',
        padding: 127,
        paddingTop: 85,
        paddingBottom: 85,
      }}
    >
      <View fixed style={{ fontSize: 22 }}>
        <Image src={HeaderLogo} style={{ width: 250, height: 'auto', marginBottom: -10 }} />

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <View style={{ flexGrow: 1 }} />
          <Text>{'社交工程演練結果報告 – '}</Text>
          <Text>{`${companyName}`}</Text>
        </View>

        <View>
          <PDFDivider style={{ width: '100%', marginBottom: 20 }} />
        </View>
      </View>

      {title && (
        <PDFTitle hideDivider={hideTitleDivider} color={color}>
          {title}
        </PDFTitle>
      )}

      <View style={{ flex: 1, paddingTop: 10, fontSize: 20 }}>{children}</View>

      <View fixed style={{ fontSize: 22 }}>
        <View>
          <PDFDivider style={{ width: '100%', marginBottom: 0 }} />
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            // alignItems: 'flex-end', // 垂直對齊到容器的底部
            justifyContent: 'flex-start', // 水平對齊到容器的左邊
            fontSize: 20,
            marginTop: 10,
          }}
        >
          {/* <View style={{ flex: 1 }} /> */}
          <Text>{'本文件之智慧財產權屬'}</Text>
          <Text>{`${secondaryCompanyFullname}`}</Text>
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            fontSize: 20,
            marginTop: -20,
            marginRight: 30,
          }}
        >
          <Text
            // render={({ pageNumber }) => padStart(`${pageNumber - 1}`, 3, '0')}
            render={({ pageNumber }) => `${pageNumber - 1}`}
          />
        </View>
      </View>
    </Page>
  )
}

export default PDFPage
